import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { investingService } from '../../services/investingService';

export const useGetBrandsForInvestment = (step = 'review') => {
  return useQuery({
    queryKey: [QUERY_KEYS.investing.investment_brands, step],
    queryFn: () =>
      investingService.brandsForInvestment({ step }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
